import { render, staticRenderFns } from "./ModalFooter.vue?vue&type=template&id=7bb7bcd6&"
import script from "./ModalFooter.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ModalFooter.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports